import React, { Fragment } from 'react';
import { PlusMinus } from '@Components/css_icon/plus_minus';
import { FaqGroupProps, FaqItem } from '../props';

import s from '../styles/FaqTab.module.css';

const ACCORDION_INNER_MARGIN = 24;

const EMPTY_GROUP: FaqGroupProps = { purchase: [], sale: [], other: [] };

type FaqProps = {
    faqs?: FaqGroupProps;
};

export const Faq = ({ faqs }: FaqProps) => {
    const { purchase, sale, other } = faqs ?? EMPTY_GROUP;
    return (
        <div className={s.tab_contents}>
            <div className={s.title}>
                <h2>よくあるご質問</h2>
            </div>
            <div className={s.link_box}>
                <a href='#purchase'>購入をご検討の方</a>
                <a href='#selling'>売却をご検討の方</a>
                <a href='#other'>その他</a>
            </div>
            <h3 id='purchase'>購入をご検討の方</h3>
            <div className={s.accordion_box}>
                {purchase.map((f) => (
                    <FaqAccordion key={f.title} {...f} />
                ))}
            </div>
            <h3 id='selling'>売却をご検討の方</h3>
            <div className={s.accordion_box}>
                {sale.map((f) => (
                    <FaqAccordion key={f.title} {...f} />
                ))}
            </div>
            <h3 id='other'>その他</h3>
            <div className={s.accordion_box}>
                {other.map((f) => (
                    <FaqAccordion key={f.title} {...f} />
                ))}
            </div>
        </div>
    );
};

export type FaqAccordionProps = FaqItem;

const FaqAccordion = (props: FaqAccordionProps) => {
    const [open, setOpen] = React.useState(false);
    const ref = React.createRef<HTMLDivElement>();
    const accordionRef = React.createRef<HTMLDivElement>();
    const doOpen = (b: boolean) => {
        const rect = ref.current.getBoundingClientRect();
        accordionRef.current.style.maxHeight = b ? `${rect.height + ACCORDION_INNER_MARGIN}px` : '0px';
        setOpen(b);
    };
    return (
        <div className={s.faq_accordion}>
            <div className={s.title} onClick={() => doOpen(!open)}>
                <span className={s.text}>{props.title}</span>
                <PlusMinus class={s.icon} type={open ? 'minus' : 'plus'} />
            </div>
            <div ref={accordionRef} className={`${s.text_content} ${open ? s.open : ''}`}>
                <div ref={ref} className={s.text_content_inner}>
                    {props.text.split('\n').map((t, i) => (
                        <Fragment key={t + i}>
                            {t}
                            <br />
                        </Fragment>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Faq;
